import { IActionButtonCommonProps } from '../../typings/DocumentViewer/actionButtonCommonProps';
import ActionButton from './actionButton';
import { Icons } from 'copyright-clearance-center-common-ui';

export interface ICustomActionButtonProps {
	title?: string;
	url?: string;
}

const CustomActionButton: React.FunctionComponent<ICustomActionButtonProps & IActionButtonCommonProps> = props => {
	const handler = () => {
		window.open(props.url, '_blank');
	};

	return (
		<ActionButton
			label={props.title}
			handler={handler}
			icon={Icons.VariantsIcon}
			isPrimary={props.isPrimary}
			testId="custom-action-btn"
			controlledBy={props.controlledBy}
		/>
	);
};

export default CustomActionButton;
